import React from 'react';

import Menu from './components/common/Menu';
import Footer from './components/common/Footer';
import Header from './components/common/Header';

import './styles/App.css';

class App extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    let currentRoutePath;

    if (this.props.routes.length > 1) {
      currentRoutePath = this.props.routes[1].path;
    }

    return (
      <div>
        <Header />
        <Menu currentPath={ currentRoutePath } />
        <section className="page-content">
          <div className="container-fluid inner-page-content">
            {this.props.children || 'Welcome to PoA'}
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js